export default {
  en: {
    title: "{orgName}'s Security Profile",
    overview: {
      lastAssessment: 'Last assessment:',
      nextReassessment: 'Reassessment:',
      orgDetails: 'Organisation details',
      assessment: 'Security assessment',
      notRequired: 'Not required domains',
      notRequired2:
        'You can still choose to fill these out if you would like to share the answers with other clients',
      added: '{n} added',
      banners: {
        autoSuggestPromptTitle: 'Want to fill your profile in faster?',
        autoSuggestPromptText: 'Upload previous assessments and documents to auto-suggest answers',
        autoSuggestPromptCTA: 'Try auto-suggest',
        submitAssessmentTitle: 'Submit your assessment',
        submitAssessmentText:
          "You're almost there - submit your details and let your clients see your answers",
        requiresAttentionTitle: 'New questions require your attention',
        requiresAttentionText:
          'You have 1 new question to answer since your last assessment | You have {n} new questions to answer since your last assessment',
        moreInfoTitle: "You've been asked to fill out more information",
        moreInfoText:
          "We've highlighted the additional controls & domains below you need to fill out",
        reassessmentDueTitle: 'Your reassessment is due {dueDate}',
        reassessmentOverdueTitle: 'Your reassessment is overdue',
        reassessmentDueText:
          "We'll ask you to confirm the answers you’ve previously provided and answer any new questions.",
        getStarted: 'Get started',
        scanningTitle: 'We are scanning your documents to find suggestions',
        scanningText:
          'This will take up to a few minutes. You can start to answer questions in the meantime.',
        autoSuggestTitle:
          'You have 1 answer suggestion ready to apply | You have {n} answer suggestions ready to apply',
        autoSuggestText:
          'Once applied, review each domain and answer to check the accuracy of the suggestions',
        autoSuggestDomainsTitle:
          "We've found answer suggestions in 1 domain | We've found answer suggestions in {n} domains",
        autoSuggestDomainsText:
          'Review each domain with suggestions to apply them. You can edit the answers at any time.',
        applyCTA: 'Apply suggestion | Apply suggestions',
        startCompletingProfileTitle: 'Start filling out your security profile',
        startCompletingProfileText:
          'Get started by filling out your organisation details and security assessment',
      },
    },
    domainCard: {
      outOfScope: 'Out of scope',
      notStarted: 'Not started',
      numAnswered: '{x} of {y} answered',
      numConfirmed: '{x} of {y} confirmed',
      suggestionsFound: '1 suggestion found | {n} suggestions found',
      suggestionsApplied: '1 suggestion applied | {n} suggestions applied',
    },
  },
};
